module.exports = __webpack_public_path__ + "static/img/history.3d8493c1.png";